import React from 'react';
import EmptyPage from '../EmptyPage';

const OrderManagePage: React.FC = () => {
  return (
    <EmptyPage
      title="주문 관리(자메이크)"
      icon="Package"
      description="자메이크 플랫폼의 주문을 관리합니다."
      parentTitle="주문"
    />
  );
};

export default OrderManagePage;
